import { autoinject, PLATFORM } from 'aurelia-framework';

import {
	ClassicPanelDialog,
	ClassicPanelDialogModel,
	ClassicPanelDialogModelDefaults,
} from '~/components/classic-panel/classic-panel-dialog';
import {
	SearchFieldModel,
	SearchType,
} from '~/components/field/common/search-definition';
import { ShortcutKey } from '~/constants';
import { FormModel } from '~/models/form-model';
import { InsertResult, isInsertResult } from '~/models/insert-result';
import { HelpFileUtils } from '~/utils/help-file-utils';
import { KeyboardShortcut } from '~/utils/keyboard-shortcut';

export interface NewBenefitPaymentDialogModel extends ClassicPanelDialogModel {
	cancelBatch?: boolean;
	cancelTransactions?: boolean;
	formModel?: FormModel;
	functionName?: string;
	recordId?: number;
	reverseTransactions?: boolean;
	onInsertSucceeded?: (InsertResult) => void;
}

const NewBenefitPaymentDialogModelDefaults: NewBenefitPaymentDialogModel = {
	...ClassicPanelDialogModelDefaults,
	cancelButtonText: 'clickable-elements.close',
	dialogSize: ClassicPanelDialog.DialogSize.MEDIUM,
};

@autoinject
export class NewBenefitPaymentDialog extends ClassicPanelDialog<NewBenefitPaymentDialogModel> {
	private static readonly BENEFITS_PAYMENTS_CENTRE_FUNCTION_NAME =
		'benefits-payments-centre';

	constructor(...rest) {
		super(...rest);
		PLATFORM.moduleName('./new-benefit-payment-dialog');
	}

	/**
	 * @override
	 */
	protected attachKeyboardShortcuts() {
		super.attachKeyboardShortcuts();
		KeyboardShortcut.subscribe(this, ShortcutKey.HelpFile, () =>
			this.openHelpFile(),
		);
	}

	/**
	 * Used by view
	 */
	private openHelpFile(): void {
		HelpFileUtils.openHelpFileIfPossible(
			NewBenefitPaymentDialog.BENEFITS_PAYMENTS_CENTRE_FUNCTION_NAME,
			undefined,
		);
	}

	/**
	 * @override
	 */
	protected formModelChanged(
		formModel: FormModel,
		oldFormModel: FormModel,
	): void {
		super.formModelChanged(formModel, oldFormModel);
		if (!formModel) {
			return;
		}
		const fieldModel: SearchFieldModel = formModel.fields.BSz_Batch_Code;
		if (fieldModel) {
			fieldModel.searchType = SearchType.BATCH_CODES;
		}
	}

	protected doSaveApi(): Promise<FormModel | InsertResult | undefined> {
		return super.doSaveApi().then((result: FormModel | InsertResult) => {
			if (isInsertResult(result) && this.model.onInsertSucceeded) {
				this.model.onInsertSucceeded(result);
			}
			return result;
		});
	}
}
